<template>
    <v-container>
        <v-layout align-center justify-center fill-height>
            <v-flex xs12 sm7 md6 lg5 xl3>
                <v-card class="elevation-5">
                    <v-toolbar class="mb-5" dark color="primary">
                        <v-toolbar-title>
                            {{ $t('mensaje_login')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-img
                            class="ml-4 mr-4"
                            :src="require('../assets/intLogo.png')"
                            height="250px"
                            contain
                    ></v-img>
                    <v-card-text>
                        <v-form class="mb-4" @submit.prevent="login">
                            <v-text-field
                                    autofocus
                                    v-model="correo"
                                    name="correo"
                                    prepend-icon="person"
                                    label="E-Mail"
                                    :error-messages="errores.email"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="password"
                                    name="password"
                                    prepend-icon="lock"
                                    :label="$t('password')"
                                    :type="show ? 'text' : 'password'"
                                    :append-icon="show ? 'visibility' : 'visibility_off'"
                                    :error-messages="errores.password"
                                    @click:append="show = !show">
                            </v-text-field>
                            <v-alert
                                    :value="alerta && !!mensajeErrorGeneral"
                                    type="warning"
                                    outline
                                    transition="scale-transition"
                            >
                                {{ mensajeErrorGeneral }}
                            </v-alert>

                            <v-card-actions>
                                <v-flex>
                                    <span>{{$t('mensaje_olvidar_contrasena')}}</span>
                                    <br>
                                    <span>{{$t('mensaje_link_restablecer1')}} <a href="/password_reset">{{$t('mensaje_link_restablecer2')}}</a> {{$t('mensaje_link_restablecer3')}}</span>
                                </v-flex>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                            <v-btn :loading="loading" color="primary" type="submit">{{$t('ingresar')}}</v-btn>
                        </v-form>

                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {AUTH_REQUEST} from '../store/actions/auth'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)


    export default {
        name: 'Login',
        data: () => ({
            show: false,
            alerta: false,
            correo: '',
            password: '',
            errores: {},
            loading: false
        }),
        computed: {
            mensajeErrorGeneral: function () {
                if (!this.errores || !this.errores.non_field_errors) {
                    return ''
                }

                if (Array.isArray(this.errores.non_field_errors)) {
                    return this.errores.non_field_errors.join(' ')
                }

                return this.errores.non_field_errors
            }
        },
        methods: {
            login: function () {
                this.errores = {}
                this.alerta = false
                this.loading = true
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$store.dispatch(AUTH_REQUEST, {email: this.correo, password: this.password})
                            .then(ok => {
                                this.loading = false
                                if(localStorage.getItem('path_confirmed') !== null){
                                    this.$router.push({ path: localStorage.getItem('path_confirmed')})
                                    localStorage.removeItem('path_confirmed')
                                }
                                else
                                if(localStorage.getItem('path_concretar') !== null){
                                    this.$router.push({ path: localStorage.getItem('path_concretar')})
                                    localStorage.removeItem('path_concretar')
                                }
                                else
                                if(localStorage.getItem('path_authorized_access') !== null){
                                    this.$router.push({ path: localStorage.getItem('path_authorized_access')})
                                    localStorage.removeItem('path_authorized_access')
                                }
                                else
                                if(localStorage.getItem('path_authorized_access_no_code') !== null){
                                    this.$router.push({ path: localStorage.getItem('path_authorized_access_no_code')})
                                    localStorage.removeItem('path_authorized_access_no_code')
                                }
                                else
                                    this.$router.push({ name: 'home'})
                            })
                            .catch(error => {
                                this.errores = this.normalizeApiErrors(error)
                                this.alerta = !!this.mensajeErrorGeneral
                                this.loading = false

                                if (this.alerta) {
                                    setTimeout(this.clear, 3000)
                                }
                            })
                    } else {
                        this.loading = false
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                    this.loading = false
                });
            },
            normalizeApiErrors: function (error) {
                const defaultMessage = 'No se pudo iniciar sesión. Intenta nuevamente.'
                const invalidCredentialsMessage = 'Correo o contraseña incorrectos.'
                const response = error && error.response ? error.response : null
                const data = response && response.data ? response.data : null
                const status = response ? response.status : null

                // Some backend failures return 500 with IntegrityError while login should behave as invalid credentials.
                if (status === 500) {
                    const rawError = typeof data === 'string' ? data : JSON.stringify(data || {})
                    const loweredRawError = rawError.toLowerCase()

                    if (
                        loweredRawError.includes('integrityerror')
                        || loweredRawError.includes('authtoken_token')
                        || loweredRawError.includes('null value in column "user_id"')
                        || loweredRawError.includes('failing row contains')
                    ) {
                        return { non_field_errors: [invalidCredentialsMessage] }
                    }
                }

                if (data && typeof data === 'object') {
                    const normalized = Object.assign({}, data)

                    if (normalized.detail && !normalized.non_field_errors) {
                        normalized.non_field_errors = [normalized.detail]
                    }

                    if (typeof normalized.non_field_errors === 'string') {
                        normalized.non_field_errors = [normalized.non_field_errors]
                    }

                    if (Array.isArray(normalized.non_field_errors)) {
                        const containsIntegrityError = normalized.non_field_errors.some((item) => {
                            if (typeof item !== 'string') {
                                return false
                            }

                            const loweredItem = item.toLowerCase()
                            return loweredItem.includes('integrityerror')
                                || loweredItem.includes('authtoken_token')
                                || loweredItem.includes('null value in column "user_id"')
                        })

                        if (containsIntegrityError) {
                            normalized.non_field_errors = [invalidCredentialsMessage]
                        }
                    }

                    return normalized
                }

                if (typeof data === 'string') {
                    return { non_field_errors: [data] }
                }

                if (status === 401) {
                    return { non_field_errors: [invalidCredentialsMessage] }
                }

                return { non_field_errors: [defaultMessage] }
            },
            clear: function(){
                this.alerta = false
                this.errores = {}
                this.$validator.reset()
            }
        }
    }
</script>
